import { render } from "./TaskCardSimple.vue?vue&type=template&id=5a3446d1"
import script from "./TaskCardSimple.vue?vue&type=script&lang=js"
export * from "./TaskCardSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__